module.exports = __webpack_public_path__ + "static/media/twinzo.504eca48.png";